import { AttendeesList, IOptionsWithTypes, SectionId } from "@eventr/common";
import { useMemo } from "react";
import { routes } from "routing";
import { useScreenTypeContext } from "../../state/screenTypeProvider";
import { FlightAttachments } from "../flightComponents/flightAttachments";
import { FlightPassengers } from "../flightComponents/flightPassengers";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { ChatButton } from "../subComponents/chatButton";
import { EditButton } from "../subComponents/editButton";
import { ExpandableSection } from "../subComponents/expendableSection";
import { ActivityPersonalItems } from "./activityPersonalInfo";

import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import i18n from "i18n/i18next";
interface IActivityBookingInfoProps {
  attendess?: AttendeesList[];
  chatNames?: string[];
  attachments?: { notes?: string; extra_docs?: string; website?: string };
  attendee?: AttendeesList;
}
export const ActivityBookingInfo = ({ attendess, chatNames, attachments, attendee }: IActivityBookingInfoProps) => {
  const { screenType } = useScreenTypeContext();
  const { _id } = useObjectContext();

  const allAttendess = useMemo(() => {
    const all: IOptionsWithTypes[] = [];
    attendess?.forEach((a) => {
      all.push(...(a.users ?? []));
    });
    return all;
  }, [attendess]);

  const end = useMemo(() => {
    if (screenType === "edit") return <EditButton path={routes.edit.activityItem.build({ itemId: _id })} />;
    if (chatNames) {
      return <ChatButton _id={_id} users={allAttendess} names={chatNames} sectionId={SectionId.ACTIVITY} />;
    }
    return null;
  }, [screenType, _id, chatNames, allAttendess]);

  if (
    !allAttendess.length &&
    !attachments?.notes &&
    !attachments?.extra_docs &&
    !attachments?.website &&
    !attendee?.documents &&
    !attendee?.notes
  )
    return (
      <Stack direction="row" sx={{
        justifyContent: "flex-end"
      }}>
        {end}
      </Stack>
    );
  return (
    <ExpandableSection mid={<CardText>{cardTranslation("Additional Information")}</CardText>} end={end}>
      <>
        {attachments && (
          <FlightAttachments
            notes={attachments.notes}
            extra_docs={attachments.extra_docs}
            website={attachments.website}
          />
        )}
        {attendee && <ActivityPersonalItems documents={attendee.documents} notes={attendee.notes} />}
        {allAttendess.length > 0 && <FlightPassengers passengers={allAttendess} title={i18n.t("cards.guests")} />}
      </>
    </ExpandableSection>
  );
};
